import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Drawer as MuiDrawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import MenuIcon from "@mui/icons-material/Menu";

import { useAuth } from "../contexts/AuthContext";

const Drawer = () => {
  const [open, setOpen] = useState(false);
  const { authToken, userRole } = useAuth();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleDrawerOpen}>
        <MenuIcon />
      </IconButton>
      <MuiDrawer anchor="left" open={open} onClose={handleDrawerClose}>
        <List>
          {authToken && userRole === "admin" && (
            <>
              <ListItem
                button
                component={Link}
                to="/places/new"
                onClick={handleDrawerClose}
              >
                <ListItemText primary="Create Place" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/dashboard"
                onClick={handleDrawerClose}
              >
                <ListItemText primary="Dashboard" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/places"
                onClick={handleDrawerClose}
              >
                <ListItemText primary="Map" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/manage-places"
                onClick={handleDrawerClose}
              >
                <ListItemText primary="Manage Places" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/listusers"
                onClick={handleDrawerClose}
              >
                <ListItemText primary="List Users" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/listreservations"
                onClick={handleDrawerClose}
              >
                <ListItemText primary="List Reservations" />
              </ListItem>
            </>
          )}
        </List>
      </MuiDrawer>
    </>
  );
};

export default Drawer;
